var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.mapsYears.min && _vm.mapsYears.max)?[_vm._v(" "+_vm._s(_vm.mapsYears.min)+" - "+_vm._s(_vm.mapsYears.max)+" ")]:[_vm._v(" unknown years ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }